import React from 'react'
import { useTranslation } from 'react-i18next'
import { ActivityIndicator, Platform, Text, TouchableOpacity, View } from 'react-native'
import { styles } from './styles'
import { white } from '../../theme/colors'
import { globalStyle } from '../../theme/global'

interface Props {
  onPressSave: () => void
  onPressSend: () => void
  isLoading: boolean
  disabled?: boolean
  sendText?: string
  hideSave?: boolean
  onPressBack?: () => void
}

export const FloatingBottomButtons = ({
  onPressSave,
  onPressSend,
  isLoading,
  disabled,
  hideSave = false,
  sendText = 'ENVIAR',
  onPressBack,
}: Props) => {
  const { t } = useTranslation()

  return (
    <View
      style={[
        styles.container,
        {
          ...(Platform.OS === 'android' ? { padding: 20 } : { padding: 20, paddingBottom: 40 }),
        },
      ]}
    >
      <View style={{ flexDirection: 'row' }}>
        {!hideSave && (
          <View style={{ flexGrow: 1, flex: 1 }}>
            <TouchableOpacity
              onPress={onPressSave}
              disabled={isLoading}
              style={styles.saveButton}
              activeOpacity={0.6}
            >
              <Text style={styles.textSaveButton}>{t('GUARDAR')}</Text>
            </TouchableOpacity>
          </View>
        )}
        <View style={{ flexGrow: 1, flex: 1 }}>
          {!isLoading && (
            <TouchableOpacity
              onPress={onPressSend}
              style={[styles.sendbutton, disabled && styles.loading]}
              activeOpacity={0.6}
              disabled={disabled}
            >
              <Text style={styles.textSendButton}>{t(sendText)}</Text>
            </TouchableOpacity>
          )}

          {isLoading && (
            <View style={[globalStyle.center, styles.loading]}>
              <ActivityIndicator size='small' color={white} />
            </View>
          )}
        </View>
      </View>
      {onPressBack && (
        <TouchableOpacity
          onPress={onPressBack}
          disabled={isLoading}
          style={[styles.saveButton, { marginTop: 10, marginRight: 0 }]}
          activeOpacity={0.6}
        >
          <Text style={styles.textSaveButton}>{t('ANTERIOR')}</Text>
        </TouchableOpacity>
      )}
    </View>
  )
}
